import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { Helmet } from 'react-helmet';
import PopularProducts from '../PopularProducts';
import ScrollToTop from '../ScrollToTop';
import { WEBSITE_URL, routerUrls } from 'constants';
import PropTypes from 'prop-types';

const pageContent = {
  adult: {
    eyebrow: 'Колекция',
    title: 'Спално бельо',
    description:
      'Разгледайте всички категории спално бельо - калъфки, чаршафи, чаршафи с ластик, кръгли чаршафи и пликове за завивки.',
    canonicalPath: routerUrls.adultCategories
  },
  kids: {
    eyebrow: 'Детска колекция',
    title: 'Детско спално бельо',
    description:
      'Разгледайте всички категории детско спално бельо - калъфки, чаршафи, чаршафи с ластик и пликове за завивки.',
    canonicalPath: routerUrls.kidsCategories,
    tileAudience: 'kids'
  },
  cottonSatin: {
    eyebrow: '100% памук',
    title: 'Спално бельо – памучен сатен',
    description:
      'Разгледайте спално бельо от памучен сатен по категории – калъфки, чаршафи, чаршафи с ластик, кръгли чаршафи с ластик и пликове за завивки.',
    canonicalPath: routerUrls.cottonSatinCategories,
    tileAudience: 'adult',
    materialId: 1,
    materialLabel: 'Памучен сатен'
  }
};

export default function CategoryLandingPage({ audience }) {
  const content = pageContent[audience];

  return (
    <ScrollToTop>
      <Helmet>
        <title>{content.title} | GoToBed</title>
        <meta name="description" content={content.description} />
        <link rel="canonical" href={`${WEBSITE_URL}${content.canonicalPath}`} />
      </Helmet>

      <Box
        component="main"
        sx={{
          bgcolor: 'background.default',
          color: 'text.primary',
          minHeight: '60vh',
          py: { xs: 6, md: 10 }
        }}>
        <Container maxWidth="lg">
          <Box sx={{ maxWidth: 760, mb: { xs: 4, md: 6 } }}>
            <Typography
              variant="overline"
              sx={{ display: 'block', color: 'gold.text', fontWeight: 700, mb: 1 }}>
              {content.eyebrow}
            </Typography>
            <Typography variant="h1" sx={{ mb: 2 }}>
              {content.title}
            </Typography>
            <Typography sx={{ color: 'text.secondary', fontSize: { xs: 16, md: 18 } }}>
              {content.description}
            </Typography>
          </Box>

          <PopularProducts
            showHeader={false}
            audience={content.tileAudience || audience}
            materialId={content.materialId}
            materialLabel={content.materialLabel}
          />
        </Container>
      </Box>
    </ScrollToTop>
  );
}

CategoryLandingPage.propTypes = {
  audience: PropTypes.oneOf(['adult', 'kids', 'cottonSatin']).isRequired
};
